/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBrandAlpineJs = createReactComponent("outline", "brand-alpine-js", "IconBrandAlpineJs", [["path", { "d": "M3 11.5l4.5 4.5h9l-9 -9z", "key": "svg-0" }], ["path", { "d": "M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5", "key": "svg-1" }]]);

export { IconBrandAlpineJs as default };
//# sourceMappingURL=IconBrandAlpineJs.mjs.map
